module.exports = __webpack_public_path__ + "img/reviewer-A.6834a8ee.png";